import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../../../src/app/core/models/generic-models';
import { IApproveBankProofRequest, IApproveBankProofResponse } from '../models/bank-proof.model';
import { approveBankProofFailure, approveBankProofRequest, approveBankProofResponse } from '../actions/bank-proofs.actions';

export const approveBankProofFeatureKey = 'approveBankProof';

export interface ApproveBankProofState {
  approveBankProofRequest: IApproveBankProofRequest;
  approveBankProofSuccess: IApproveBankProofResponse;
  approveBankProofFailure: IGenericError<ErrorResponse>;
}

export const initialState: ApproveBankProofState = {
  approveBankProofRequest: undefined,
  approveBankProofSuccess: undefined,
  approveBankProofFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(approveBankProofRequest, (state, action) => ({
    ...state,
    approveBankProofRequest: action.request
  })),
  on(approveBankProofResponse, (state, action) => ({
    ...state,
    approveBankProofSuccess: action.response
  })),
  on(approveBankProofFailure, (state, action) => ({
    ...state,
    approveBankProofFailure: action.error
  }))
);

export const getApproveBankProofRequest = (state: ApproveBankProofState) => state.approveBankProofRequest;
export const getApproveBankProofResponse = (state: ApproveBankProofState) => state.approveBankProofSuccess;
export const getApproveBankProofFailure = (state: ApproveBankProofState) => state.approveBankProofFailure;
